var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaintraMobileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 30,
    viewBox: "0 0 75 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4121_79312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1241 6.50929L34.6873 7.06585C34.1973 6.56281 33.5101 6.26312 32.807 6.26312C31.3741 6.26312 30.2236 7.37624 30.2236 8.77835C30.2236 10.1805 31.3741 11.2936 32.807 11.2936C33.5048 11.2936 34.1866 10.9992 34.6873 10.5283L35.1295 11.0313C34.5009 11.6254 33.6486 12.016 32.7697 12.016C30.9373 12.016 29.4832 10.5872 29.4832 8.77835C29.4832 6.96953 30.9533 5.57812 32.7964 5.57812C33.6699 5.57812 34.5116 5.93133 35.1188 6.50929H35.1241Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9672 10.3625L36.2587 11.9786H35.4863L38.3361 5.59961H39.0872L41.9263 11.9786H41.138L40.4295 10.3625H36.9618H36.9672ZM38.693 6.42375L37.2761 9.66143H40.1259L38.693 6.42375Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9331 11.9786V5.59961H43.6575V11.9786H42.9331Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1187 11.9786L46.3101 6.85722V11.9786H45.5857V5.59961H46.3368L50.1507 10.7317V5.59961H50.8698V11.9786H50.124H50.1187Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7316 6.30066V11.9786H54.0072V6.30066H51.9404V5.59961H56.8144V6.30066H54.7369H54.7316Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7029 9.94455C60.5644 9.95526 60.4206 9.96061 60.2768 9.96061H58.5882V11.9728H57.8638V5.59375H60.2768C61.8641 5.59375 62.7803 6.38043 62.7803 7.73437C62.7803 8.79397 62.2743 9.50037 61.3581 9.80541L62.8442 11.9728H62.0186L60.7029 9.9392V9.94455ZM60.2768 9.25956C61.4273 9.25956 62.0825 8.75116 62.0825 7.75577C62.0825 6.76039 61.4273 6.2948 60.2768 6.2948H58.5882V9.25956H60.2768Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9803 10.3625L64.2719 11.9786H63.4995L66.3493 5.59961H67.1004L69.9395 11.9786H69.1511L68.4427 10.3625H64.975H64.9803ZM66.7062 6.42375L65.2893 9.66143H68.1391L66.7062 6.42375Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3959 15.0993L34.1814 16.5496C33.7979 16.0305 33.2279 15.6933 32.7379 15.6933C31.9761 15.6933 31.4222 16.3034 31.4222 17.1543C31.4222 18.0052 31.9761 18.6313 32.7379 18.6313C33.1906 18.6313 33.7606 18.3477 34.1814 17.9035L35.3959 19.2093C34.6874 19.9852 33.6061 20.4883 32.626 20.4883C30.6764 20.4883 29.2595 19.0915 29.2595 17.1864C29.2595 15.2812 30.7137 13.9434 32.7059 13.9434C33.6754 13.9434 34.7407 14.3982 35.3906 15.11L35.3959 15.0993Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4005 17.1912C42.4005 19.0857 40.9303 20.4824 38.9062 20.4824C36.882 20.4824 35.4119 19.0964 35.4119 17.1912C35.4119 15.2861 36.882 13.9375 38.9062 13.9375C40.9303 13.9375 42.4005 15.3075 42.4005 17.1912ZM37.5745 17.1966C37.5745 18.0742 38.2084 18.7164 38.9381 18.7164C39.6679 18.7164 40.2432 18.0689 40.2432 17.1966C40.2432 16.3243 39.6626 15.6928 38.9381 15.6928C38.2137 15.6928 37.5745 16.3243 37.5745 17.1966Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4129 20.3917L44.9094 17.1273V20.3917H42.9971V14.002H44.7549L47.2691 17.2824V14.002H49.176V20.3917H47.4182H47.4129Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5028 20.3917L51.9992 17.1273V20.3917H50.0869V14.002H51.8447L54.3589 17.2824V14.002H56.2659V20.3917H54.5081H54.5028Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2808 15.6021V16.3887H62.2584V17.9942H59.2808V18.7862H62.6366V20.3917H57.1714V14.002H62.5514V15.6074H59.2754L59.2808 15.6021Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2523 15.0993L68.0378 16.5496C67.6543 16.0305 67.0844 15.6933 66.5943 15.6933C65.8326 15.6933 65.2786 16.3034 65.2786 17.1543C65.2786 18.0052 65.8326 18.6313 66.5943 18.6313C67.0471 18.6313 67.6224 18.3477 68.0378 17.9035L69.2523 19.2093C68.5439 19.9852 67.4626 20.4883 66.4824 20.4883C64.5329 20.4883 63.116 19.0915 63.116 17.1864C63.116 15.2812 64.5702 13.9434 66.5623 13.9434C67.5318 13.9434 68.5971 14.3982 69.247 15.11L69.2523 15.0993Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1835 15.6658V20.3858H71.0794V15.6658H69.2737V13.9961H74.9999V15.6658H73.1835Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3235 23.9991V22.6719H29.4726V23.9991H29.3235Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8203 23.9991L30.0266 22.9341V23.9991H29.8774V22.6719H30.0319L30.8256 23.7368V22.6719H30.9747V23.9991H30.8203Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3171 23.9991L31.5234 22.9341V23.9991H31.3743V22.6719H31.5287L32.3224 23.7368V22.6719H32.4716V23.9991H32.3171Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1335 23.335C34.1335 23.7096 33.8299 24.0039 33.441 24.0039C33.0522 24.0039 32.7485 23.7042 32.7485 23.335C32.7485 22.9657 33.0522 22.666 33.441 22.666C33.8299 22.666 34.1335 22.9604 34.1335 23.335ZM32.903 23.335C32.903 23.6293 33.148 23.8594 33.441 23.8594C33.734 23.8594 33.979 23.6239 33.979 23.335C33.979 23.046 33.7393 22.8105 33.441 22.8105C33.1427 22.8105 32.903 23.0406 32.903 23.335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7407 23.9991L34.208 22.6719H34.3678L34.8206 23.8225L35.2787 22.6719H35.4385L34.9005 23.9991H34.746H34.7407Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6783 23.6658L35.5292 24.003H35.3694L35.9606 22.6758H36.1151L36.7064 24.003H36.5413L36.3921 23.6658H35.673H35.6783ZM36.0352 22.847L35.7423 23.5213H36.3335L36.0352 22.847Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8623 23.9991L37.0686 22.9341V23.9991H36.9194V22.6719H37.0739L37.8676 23.7368V22.6719H38.0167V23.9991H37.8623Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9541 22.6719C39.3376 22.6719 39.6306 22.9555 39.6306 23.3355C39.6306 23.7154 39.3323 23.9991 38.9487 23.9991H38.4214V22.6719H38.9541ZM38.5705 23.8546H38.9541C39.247 23.8546 39.4761 23.6352 39.4761 23.3355C39.4761 23.0358 39.2417 22.8164 38.9487 22.8164H38.5705V23.8546Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1327 23.335C41.1327 23.7096 40.8291 24.0039 40.4403 24.0039C40.0514 24.0039 39.7478 23.7042 39.7478 23.335C39.7478 22.9657 40.0514 22.666 40.4403 22.666C40.8291 22.666 41.1327 22.9604 41.1327 23.335ZM39.9023 23.335C39.9023 23.6293 40.1473 23.8594 40.4403 23.8594C40.7332 23.8594 40.9783 23.6239 40.9783 23.335C40.9783 23.046 40.7386 22.8105 40.4403 22.8105C40.142 22.8105 39.9023 23.0406 39.9023 23.335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0756 22.8217V23.2552H42.7415V23.3997H42.0756V23.8546H42.8427V23.9991H41.9211V22.6719H42.816V22.8164H42.0703L42.0756 22.8217Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0998 23.9991L43.3061 22.9341V23.9991H43.157V22.6719H43.3115L44.1051 23.7368V22.6719H44.2543V23.9991H44.0998Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4328 23.335C46.4328 23.7096 46.1292 24.0039 45.7403 24.0039C45.3515 24.0039 45.0479 23.7042 45.0479 23.335C45.0479 22.9657 45.3515 22.666 45.7403 22.666C46.1292 22.666 46.4328 22.9604 46.4328 23.335ZM45.2023 23.335C45.2023 23.6293 45.4474 23.8594 45.7403 23.8594C46.0333 23.8594 46.2783 23.6239 46.2783 23.335C46.2783 23.046 46.0386 22.8105 45.7403 22.8105C45.442 22.8105 45.2023 23.0406 45.2023 23.335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2053 22.6714C47.5303 22.6714 47.722 22.8319 47.722 23.1155C47.722 23.3992 47.5356 23.5758 47.2053 23.5758H46.8591V23.9932H46.71V22.666H47.2053V22.6714ZM46.8591 23.4366H47.2C47.4397 23.4366 47.5729 23.3296 47.5729 23.1262C47.5729 22.9229 47.4344 22.8212 47.2 22.8212H46.8591V23.4366Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2294 23.335C49.2294 23.7096 48.9258 24.0039 48.537 24.0039C48.1481 24.0039 47.8445 23.7042 47.8445 23.335C47.8445 22.9657 48.1481 22.666 48.537 22.666C48.9258 22.666 49.2294 22.9604 49.2294 23.335ZM47.999 23.335C47.999 23.6293 48.244 23.8594 48.537 23.8594C48.8299 23.8594 49.0749 23.6239 49.0749 23.335C49.0749 23.046 48.8353 22.8105 48.537 22.8105C48.2387 22.8105 47.999 23.0406 47.999 23.335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0922 23.5758C50.0656 23.5758 50.0336 23.5758 50.0017 23.5758H49.6501V23.9932H49.501V22.666H50.0017C50.3319 22.666 50.5237 22.8266 50.5237 23.1102C50.5237 23.3296 50.4172 23.4794 50.2254 23.5383L50.5344 23.9878H50.3639L50.0922 23.5651V23.5758ZM50.007 23.4366C50.2467 23.4366 50.3799 23.3296 50.3799 23.1262C50.3799 22.9229 50.2467 22.8212 50.007 22.8212H49.6555V23.4366H50.007Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2696 22.8203V24.003H51.1204V22.8203H50.689V22.6758H51.701V22.8203H51.2696Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0008 23.4532C53.0008 23.7957 52.793 24.0044 52.4468 24.0044C52.1006 24.0044 51.8928 23.7957 51.8928 23.4532V22.6719H52.042V23.4532C52.042 23.7101 52.1964 23.8599 52.4468 23.8599C52.6972 23.8599 52.8463 23.7101 52.8463 23.4532V22.6719H52.9955V23.4532H53.0008Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3164 23.9991L53.5227 22.9341V23.9991H53.3735V22.6719H53.528L54.3217 23.7368V22.6719H54.4708V23.9991H54.3164Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8704 23.9991V22.6719H55.0195V23.9991H54.8704Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9569 22.6719C56.3405 22.6719 56.6334 22.9555 56.6334 23.3355C56.6334 23.7154 56.3351 23.9991 55.9463 23.9991H55.4189V22.6719H55.9516H55.9569ZM55.5734 23.8546H55.9569C56.2499 23.8546 56.479 23.6352 56.479 23.3355C56.479 23.0358 56.2446 22.8164 55.9516 22.8164H55.5734V23.8546Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9957 23.6658L56.8466 24.003H56.6868L57.278 22.6758H57.4325L58.0238 24.003H57.8586L57.7095 23.6658H56.9904H56.9957ZM57.3526 22.847L57.0596 23.5213H57.6509L57.3526 22.847Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7694 22.6719C59.153 22.6719 59.4459 22.9555 59.4459 23.3355C59.4459 23.7154 59.1476 23.9991 58.7588 23.9991H58.2314V22.6719H58.7641H58.7694ZM58.3859 23.8546H58.7694C59.0624 23.8546 59.2915 23.6352 59.2915 23.3355C59.2915 23.0358 59.0571 22.8164 58.7641 22.8164H58.3859V23.8546Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8722 22.8217V23.2552H60.5381V23.3997H59.8722V23.8546H60.6393V23.9991H59.7178V22.6719H60.6127V22.8164H59.8669L59.8722 22.8217Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.763 22.7896L61.6991 22.9341C61.5819 22.8538 61.4381 22.8217 61.3369 22.8217C61.1665 22.8217 61.0546 22.8859 61.0546 22.9983C61.0546 23.3408 61.795 23.1589 61.795 23.6405C61.795 23.8599 61.6032 24.0044 61.3156 24.0044C61.1238 24.0044 60.9321 23.9188 60.8096 23.8011L60.8788 23.6673C61.0013 23.785 61.1718 23.8546 61.3156 23.8546C61.5074 23.8546 61.6246 23.7743 61.6246 23.6512C61.6246 23.3034 60.8841 23.4907 60.8841 23.0144C60.8841 22.8057 61.0653 22.6719 61.3422 22.6719C61.4967 22.6719 61.6512 22.72 61.763 22.795V22.7896Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1535 22.6719C63.537 22.6719 63.83 22.9555 63.83 23.3355C63.83 23.7154 63.5317 23.9991 63.1428 23.9991H62.6155V22.6719H63.1481H63.1535ZM62.7753 23.8546H63.1588C63.4518 23.8546 63.6808 23.6352 63.6808 23.3355C63.6808 23.0358 63.4464 22.8164 63.1535 22.8164H62.7753V23.8546Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2614 22.8217V23.2552H64.9272V23.3997H64.2614V23.8546H65.0285V23.9991H64.1069V22.6719H65.0018V22.8164H64.2561L64.2614 22.8217Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8022 23.9991L66.0085 22.9341V23.9991H65.8594V22.6719H66.0138L66.8075 23.7368V22.6719H66.9567V23.9991H66.8022Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5107 22.8217V23.2552H68.1765V23.3997H67.5107V23.8546H68.2777V23.9991H67.3562V22.6719H68.2511V22.8164H67.5054L67.5107 22.8217Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6413 23.3515V23.8332C69.5135 23.9402 69.327 24.0098 69.1513 24.0098C68.7677 24.0098 68.4641 23.7101 68.4641 23.3408C68.4641 22.9716 68.7731 22.6719 69.1619 22.6719C69.343 22.6719 69.5241 22.7414 69.6466 22.8538L69.5614 22.9662C69.4549 22.8699 69.3111 22.811 69.1619 22.811C68.8583 22.811 68.6186 23.0465 68.6186 23.3355C68.6186 23.6244 68.8636 23.8599 69.1619 23.8599C69.2791 23.8599 69.4069 23.8171 69.5082 23.7475V23.3462H69.6413V23.3515Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.266 23.335C71.266 23.7096 70.9624 24.0039 70.5736 24.0039C70.1847 24.0039 69.8811 23.7042 69.8811 23.335C69.8811 22.9657 70.1847 22.666 70.5736 22.666C70.9624 22.666 71.266 22.9604 71.266 23.335ZM70.0356 23.335C70.0356 23.6293 70.2806 23.8594 70.5736 23.8594C70.8665 23.8594 71.1116 23.6239 71.1116 23.335C71.1116 23.046 70.8719 22.8105 70.5736 22.8105C70.2753 22.8105 70.0356 23.0406 70.0356 23.335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5549 22.8645L72.4644 22.9823C72.3632 22.8806 72.2194 22.8164 72.0755 22.8164C71.7772 22.8164 71.5375 23.0465 71.5375 23.3408C71.5375 23.6352 71.7772 23.8653 72.0755 23.8653C72.2194 23.8653 72.3632 23.8064 72.4644 23.7047L72.5549 23.8064C72.4271 23.9295 72.246 24.0098 72.0649 24.0098C71.6867 24.0098 71.3831 23.7101 71.3831 23.3355C71.3831 22.9609 71.6867 22.6719 72.0702 22.6719C72.2513 22.6719 72.4271 22.7468 72.5549 22.8645Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.832 23.9991V22.6719H72.9812V23.9991H72.832Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6379 23.335C74.6379 23.7096 74.3343 24.0039 73.9454 24.0039C73.5566 24.0039 73.2529 23.7042 73.2529 23.335C73.2529 22.9657 73.5566 22.666 73.9454 22.666C74.3343 22.666 74.6379 22.9604 74.6379 23.335ZM73.4127 23.335C73.4127 23.6293 73.6578 23.8594 73.9507 23.8594C74.2437 23.8594 74.4887 23.6239 74.4887 23.335C74.4887 23.046 74.249 22.8105 73.9507 22.8105C73.6524 22.8105 73.4127 23.0406 73.4127 23.335Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1591 9.39816L24.0767 8.28504C24.0501 8.10844 24.0821 7.91578 24.1779 7.74988C24.407 7.34852 24.9183 7.20938 25.3178 7.44485C25.712 7.67496 25.8505 8.18336 25.6215 8.58472C25.3924 8.98609 24.8811 9.12523 24.4816 8.88976C24.4496 8.87371 24.4176 8.8523 24.3857 8.82554L22.4681 9.93866C22.4894 10.035 22.5053 10.1313 22.5053 10.233C22.5053 10.8752 21.9833 11.3943 21.3441 11.3943C20.7049 11.3943 20.1882 10.8752 20.1882 10.233C20.1882 9.59081 20.7049 9.06636 21.3441 9.06636C21.6637 9.06636 21.946 9.1948 22.1591 9.39816Z",
    fill: "url(#paint0_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7333 21.8305C25.7333 22.2907 25.3605 22.6653 24.9024 22.6653C24.4443 22.6653 24.0661 22.2907 24.0661 21.8305C24.0661 21.7877 24.0714 21.7502 24.0767 21.7128L22.1591 20.5943C21.946 20.803 21.6637 20.9314 21.3441 20.9314C20.7049 20.9314 20.1882 20.407 20.1882 19.7648C20.1882 19.1226 20.7049 18.6035 21.3441 18.6035C21.9833 18.6035 22.5053 19.1226 22.5053 19.7648C22.5053 19.8665 22.4894 19.9628 22.4681 20.0591L24.3857 21.1723C24.5295 21.0599 24.7053 20.9903 24.9024 20.9903C25.3605 20.9903 25.7333 21.3649 25.7333 21.8305Z",
    fill: "url(#paint1_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0522 7.01613L20.5238 5.58191C20.4759 5.25547 20.6303 4.91297 20.9286 4.74172C21.3281 4.50625 21.8395 4.64539 22.0686 5.04676C22.2976 5.44812 22.1591 5.95652 21.7649 6.18664C21.4613 6.36324 21.0938 6.32578 20.8328 6.12242L18.3665 7.55663C18.3878 7.64761 18.3985 7.74929 18.3985 7.84561C18.3985 8.4878 17.8818 9.01225 17.2426 9.01225C16.6034 9.01225 16.0867 8.4878 16.0867 7.84561C16.0867 7.20343 16.6034 6.68433 17.2426 6.68433C17.5568 6.68433 17.8445 6.81277 18.0522 7.01613Z",
    fill: "url(#paint2_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1804 24.5324C22.1804 24.9927 21.8076 25.3673 21.3441 25.3673C20.8807 25.3673 20.5132 24.9927 20.5132 24.5324C20.5132 24.4896 20.5185 24.4522 20.5238 24.4147L18.0522 22.9805C17.8445 23.1839 17.5568 23.3123 17.2426 23.3123C16.6034 23.3123 16.0867 22.7932 16.0867 22.1457C16.0867 21.4981 16.6034 20.9844 17.2426 20.9844C17.8818 20.9844 18.3985 21.5035 18.3985 22.1457C18.3985 22.2473 18.3878 22.3437 18.3665 22.44L20.8328 23.8742C20.9766 23.7618 21.1524 23.6923 21.3441 23.6923C21.8076 23.6923 22.1804 24.0722 22.1804 24.5324Z",
    fill: "url(#paint3_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9683 17.5487C19.1973 17.9501 19.0642 18.4585 18.6647 18.6886C18.2652 18.9241 17.7591 18.7849 17.5301 18.3836C17.301 17.9822 17.4342 17.4738 17.8337 17.2437C18.2332 17.0082 18.7392 17.1473 18.9683 17.5487Z",
    fill: "url(#paint4_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6647 12.7547C18.2652 12.9901 17.7591 12.851 17.5301 12.4496C17.301 12.0483 17.4342 11.5399 17.8337 11.3044C18.2332 11.0743 18.7392 11.2134 18.9683 11.6148C19.1973 12.0108 19.0642 12.5245 18.6647 12.7547Z",
    fill: "url(#paint5_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4219 1.75645C12.1929 1.35509 12.326 0.841338 12.7255 0.611222C13.1251 0.381106 13.6311 0.520246 13.8601 0.91626C14.0892 1.31763 13.956 1.83137 13.5565 2.06149C13.157 2.29161 12.651 2.15782 12.4219 1.75645Z",
    fill: "url(#paint6_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9851 5.46461C11.9851 4.82242 12.5018 4.29797 13.141 4.29797C13.4553 4.29797 13.7429 4.42641 13.9507 4.63512L16.4223 3.20091C16.3743 2.86911 16.5235 2.53196 16.8271 2.35536C17.2266 2.12525 17.7326 2.26439 17.9617 2.6604C18.196 3.06177 18.0576 3.57551 17.658 3.80563C17.3544 3.98223 16.9869 3.94477 16.7312 3.74141L14.2596 5.17562C14.2862 5.2666 14.2969 5.36293 14.2969 5.46461C14.2969 6.10679 13.7802 6.63124 13.141 6.63124C12.5018 6.63124 11.9851 6.10679 11.9851 5.46461Z",
    fill: "url(#paint7_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0735 26.9133C18.0735 27.3789 17.7007 27.7535 17.2426 27.7535C16.7845 27.7535 16.4116 27.3789 16.4116 26.9133C16.4116 26.8758 16.4169 26.833 16.4223 26.7956L13.9507 25.3614C13.7429 25.5701 13.4553 25.6932 13.141 25.6932C12.5018 25.6932 11.9851 25.1741 11.9851 24.5319C11.9851 23.8897 12.5018 23.3652 13.141 23.3652C13.7802 23.3652 14.2969 23.8897 14.2969 24.5319C14.2969 24.6335 14.2862 24.7299 14.2596 24.8209L16.7312 26.2551C16.8697 26.1427 17.0508 26.0785 17.2426 26.0785C17.7007 26.0785 18.0735 26.4531 18.0735 26.9133Z",
    fill: "url(#paint8_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5565 9.78922C13.157 10.0193 12.651 9.8802 12.4219 9.48418C12.1929 9.08282 12.326 8.56907 12.7255 8.33895C13.1251 8.10884 13.6311 8.24262 13.8601 8.64399C14.0892 9.04536 13.956 9.5591 13.5565 9.78922Z",
    fill: "url(#paint9_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8601 20.5139C14.0892 20.9153 13.956 21.429 13.5565 21.6591C13.157 21.8893 12.651 21.7501 12.4219 21.3541C12.1929 20.9527 12.326 20.439 12.7255 20.2089C13.1251 19.9788 13.6311 20.1179 13.8601 20.5139Z",
    fill: "url(#paint10_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1953 7.8472C10.1953 8.48939 9.6786 9.01384 9.0394 9.01384C8.40019 9.01384 7.87817 8.48939 7.87817 7.8472C7.87817 7.31205 8.24039 6.86252 8.73045 6.72873V3.86031C8.4215 3.73722 8.20843 3.43218 8.20843 3.08433C8.20843 2.61875 8.57597 2.24414 9.0394 2.24414C9.50282 2.24414 9.87036 2.61875 9.87036 3.08433C9.87036 3.43218 9.65197 3.73722 9.34834 3.86031V6.72873C9.83307 6.86252 10.1953 7.31205 10.1953 7.8472Z",
    fill: "url(#paint11_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8601 28.2416C14.0892 28.643 13.956 29.1514 13.5565 29.3869C13.157 29.617 12.651 29.4779 12.4219 29.0765C12.1929 28.6805 12.326 28.1667 12.7255 27.9366C13.1251 27.7065 13.6311 27.8403 13.8601 28.2416Z",
    fill: "url(#paint12_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31345 18.3836C7.07908 17.9822 7.21757 17.4738 7.61708 17.2437C8.01125 17.0082 8.52262 17.1473 8.75166 17.5487C8.98071 17.9501 8.84754 18.4585 8.44804 18.6886C8.04854 18.9241 7.5425 18.7849 7.31345 18.3836Z",
    fill: "url(#paint13_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34834 23.2695V26.1379C9.51347 26.2075 9.66262 26.3252 9.7585 26.4965C9.98755 26.8978 9.84905 27.4062 9.45488 27.6417C9.05538 27.8718 8.54934 27.7327 8.31496 27.3313C8.08592 26.9353 8.22441 26.4215 8.62391 26.1914C8.65587 26.17 8.69316 26.154 8.72512 26.1379V23.2695C8.24039 23.1357 7.87817 22.6808 7.87817 22.1457C7.87817 21.5035 8.40019 20.9844 9.0394 20.9844C9.6786 20.9844 10.1953 21.5035 10.1953 22.1457C10.1953 22.6808 9.8384 23.1357 9.34834 23.2695Z",
    fill: "url(#paint14_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31345 12.4496C7.07908 12.0483 7.21757 11.5399 7.61708 11.3044C8.01125 11.0743 8.52262 11.2134 8.75166 11.6148C8.98071 12.0108 8.84754 12.5245 8.44804 12.7547C8.04854 12.9901 7.5425 12.851 7.31345 12.4496Z",
    fill: "url(#paint15_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09373 10.2339C6.09373 10.8761 5.57171 11.3952 4.93251 11.3952C4.2933 11.3952 3.77661 10.8761 3.77661 10.2339C3.77661 9.69877 4.1335 9.24924 4.62356 9.1101V6.24167C4.31994 6.11859 4.10154 5.8189 4.10154 5.4657C4.10154 5.00547 4.47441 4.63086 4.93251 4.63086C5.3906 4.63086 5.76347 5.00547 5.76347 5.4657C5.76347 5.8189 5.5504 6.11859 5.24678 6.24167V9.1101C5.73151 9.24924 6.09373 9.69877 6.09373 10.2339Z",
    fill: "url(#paint16_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37955 9.00171C1.83848 9.00171 2.21052 8.62794 2.21052 8.16687C2.21052 7.7058 1.83848 7.33203 1.37955 7.33203C0.92062 7.33203 0.548584 7.7058 0.548584 8.16687C0.548584 8.62794 0.92062 9.00171 1.37955 9.00171Z",
    fill: "url(#paint17_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24146 20.8886V23.757C5.41191 23.8213 5.55573 23.9444 5.65694 24.1156C5.88599 24.5116 5.74749 25.0254 5.34799 25.2555C4.95381 25.4856 4.44245 25.3518 4.2134 24.9504C3.98435 24.5491 4.12285 24.0407 4.51702 23.8052C4.55431 23.7892 4.58627 23.7678 4.62356 23.757V20.8886C4.1335 20.7495 3.77661 20.3 3.77661 19.7648C3.77661 19.1226 4.2933 18.6035 4.93251 18.6035C5.57171 18.6035 6.09373 19.1226 6.09373 19.7648C6.09373 20.3 5.73151 20.7495 5.24146 20.8886Z",
    fill: "url(#paint18_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10399 22.2484C1.86961 22.6498 1.36358 22.7836 0.964074 22.5535C0.564571 22.3234 0.431404 21.8096 0.660452 21.4136C0.8895 21.0122 1.40086 20.8731 1.79504 21.1032C2.19454 21.3387 2.33304 21.8471 2.10399 22.2484Z",
    fill: "url(#paint19_radial_4121_79312)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09376 14.996C6.09376 15.6435 5.57174 16.1626 4.93254 16.1626C4.61826 16.1626 4.33062 16.0342 4.12288 15.8308L1.65661 17.2651C1.67792 17.4417 1.65661 17.629 1.55008 17.8002C1.32103 18.2016 0.814993 18.3354 0.41549 18.1053C0.0159873 17.8751 -0.11718 17.3614 0.111868 16.9654C0.340916 16.564 0.846953 16.4249 1.24646 16.655C1.28374 16.6764 1.3157 16.6978 1.34766 16.7246L3.81393 15.2903C3.79262 15.194 3.77664 15.0977 3.77664 14.996C3.77664 14.8997 3.79262 14.798 3.81393 14.707L1.34234 13.2728C1.08665 13.4762 0.719112 13.5136 0.41549 13.337C0.0159873 13.1069 -0.11718 12.5985 0.111868 12.1971C0.340916 11.7958 0.846953 11.6566 1.24646 11.8921C1.55008 12.0634 1.69923 12.4059 1.65661 12.7323L4.12288 14.1665C4.33062 13.9632 4.61826 13.8347 4.93254 13.8347C5.57174 13.8347 6.09376 14.3538 6.09376 14.996Z",
    fill: "url(#paint20_radial_4121_79312)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.002) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0027) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0014) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0021) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2527 16.0021) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2527 16.003) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0023) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0018) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0015) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 0.766517) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 0.766741) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.003) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2529 16.0027) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2527 16.0021) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.0021) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2527 16.003) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.0029) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.0015) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.0027) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.0032) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4121_79312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2528 16.0021) scale(12.587 12.6457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4121_79312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 29,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaintraMobileIcon);
export default __webpack_public_path__ + "static/media/CaintraMobileIcon.ae3a5e2a89e1e69dd9d908a0965bb2ca.svg";
export { ForwardRef as ReactComponent };